import { useMemo } from 'react';

import type { AppliedDiscountTemp, CartItemTemp } from '@dutchie-pos/types/temp';

export const useApplicableItemDiscounts = (cartItem?: CartItemTemp, discounts?: AppliedDiscountTemp[]) =>
  useMemo(() => {
    if (!cartItem || !discounts) {
      return [];
    }
    return discounts.filter((discount) => cartItem.RowInventoryIds?.includes(discount.InvId));
  }, [cartItem, discounts]);
